/**
 * Created by Jerker Nord on 2019-03-21.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {ThorGameConfig} from "../../ThorGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ThorGameAssets} from "../../ThorGameAssets";
import {TimelineLite, TweenLite} from "gsap";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {IconState, IIconView} from "../IIconView";

export class ThorRandomWildIconView extends BaseView implements IIconView {
    get fsIconIsVisible():boolean {
        return this._fsIconIsVisible;
    }
    set fsIconIsVisible(value:boolean) {
        this._fsIconIsVisible = value;
        this.onResize(this._resizeData);
    }
    private _fsIconIsVisible:boolean = false;

    private static RANDOMW_WILD_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(1104, 125);
    private static RANDOM_WILD_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(714, -91);
    public static thorRandomWildIconView:ThorRandomWildIconView;

    private _randomWildIconDisabled:PIXI.Sprite;
    private _randomWildIconEnabled:PIXI.Sprite;
    private _randomWildContainer:PIXI.Container;
    private _layer:ScalableLayer;
    private _state:IconState;
    private _enableRandomWildIconSelectTL:TimelineLite;
    private _disableRandomWildIconTL:TimelineLite;

    constructor() {
        super();
        this._layer = StageManager.getLayer(ThorGameConfig.instance.LAYERS.SCATTER_ANIMATION.name);
        this._layer.addChild(this);
        this._randomWildContainer = new PIXI.Container();
        this.addChild(this._randomWildContainer);
        this._state = IconState.disabled;
        ThorRandomWildIconView.thorRandomWildIconView = this;
    }

    protected onResize(resizeData:IResizeData):void {
        if(resizeData.orientation == Orientation.PORTRAIT) {
            this._randomWildContainer.position = ThorRandomWildIconView.RANDOM_WILD_CONTAINER_PORTRAIT_POSITION;
            if (!this.fsIconIsVisible){
                this._randomWildContainer.position.x = ThorRandomWildIconView.RANDOM_WILD_CONTAINER_PORTRAIT_POSITION.x + 130;
            }
            this._randomWildContainer.scale.set(1.2, 1.2);
        } else {
            this._randomWildContainer.position = ThorRandomWildIconView.RANDOMW_WILD_CONTAINER_LANDSCAPE_POSITION;
            this._randomWildContainer.scale.set(1, 1);
        }
    }

    protected initAnimations():void {
        this._randomWildIconDisabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_RANDOM_WILDS_DISABLED)[0]);
        this._randomWildContainer.addChild(this._randomWildIconDisabled);
        this._randomWildIconEnabled = new PIXI.Sprite(GameResources.getTextures(ThorGameAssets.ICON_RANDOM_WILDS_ENABLED)[0]);
        this._randomWildIconEnabled.alpha = 0;
        this._randomWildContainer.addChild(this._randomWildIconEnabled);
    }

    public abort():void{
        if(this._enableRandomWildIconSelectTL && this._enableRandomWildIconSelectTL.isActive()) {
            this._enableRandomWildIconSelectTL.pause();
            this._enableRandomWildIconSelectTL.kill();
        }
    }

    public enableRandomWildIconSelectTL(isFreeSpin:boolean):TimelineLite {
        if(this._enableRandomWildIconSelectTL && this._enableRandomWildIconSelectTL.isActive()) {
            this._enableRandomWildIconSelectTL.pause();
            this._enableRandomWildIconSelectTL.kill();
        }
        this._enableRandomWildIconSelectTL = new TimelineLite();
        this._enableRandomWildIconSelectTL.add(ThorGameModuleConfig.thorMjolnirtimeView.getIconSelectAnimation(1, isFreeSpin));
        return this._enableRandomWildIconSelectTL;
    }

    public disableRandomWildIconTL(delay:number):TimelineLite {
        if(this._disableRandomWildIconTL && this._disableRandomWildIconTL.isActive()) {
            this._disableRandomWildIconTL.pause();
            this._disableRandomWildIconTL.kill();
        }

        this._disableRandomWildIconTL = new TimelineLite({delay : delay});
        this._disableRandomWildIconTL.add([
            new TweenLite(this._randomWildIconEnabled, 0.4, {alpha : 0}),
            new TweenLite(this._randomWildIconDisabled, 0.2, {alpha : 1})
        ]);
        this._disableRandomWildIconTL.add(() => this.setState(IconState.disabled));
        return this._disableRandomWildIconTL;
    }

    public getState():IconState {
        return this._state;
    }

    public setState(state:IconState):void {
        this._state = state;
        switch(state) {
            case IconState.disabled:
                this._randomWildIconDisabled.alpha = 1;
                this._randomWildIconEnabled.alpha = 0;
                break;
            case IconState.enabled:
                this._randomWildIconEnabled.alpha = 1;
                this._randomWildIconDisabled.alpha = 0;
                break;
            case IconState.activated:
                this._randomWildIconEnabled.alpha = 1;
                this._randomWildIconDisabled.alpha = 0;
                break;
            default:
                debugger;
                throw new Error("IconStates.setState(): Illegal icon state " + state);
        }
    }
}